module.exports = __webpack_public_path__ + "img/navegacao-proximo.cf4a5530.svg";